import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import css from './RouteTransitionProgress.module.css';

const RouteTransitionProgress = ({ isVisible }) => {
  return (
    <div
      className={classNames(css.root, {
        [css.visible]: isVisible,
      })}
      aria-hidden={!isVisible}
    >
      <div className={css.barTrack}>
        <div className={css.bar} />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  isVisible: state.routing?.isRouteTransitioning || false,
});

export default connect(mapStateToProps)(RouteTransitionProgress);
